<template>
  <vue-slider
    v-model="weightToApplyToAddedHandsVModel"
    ref="vueSlider"
    class="vertical-set-weight-to-apply-to-added-hands-basic"
    v-bind="sliderOptions"
    v-bind:disabled="disabled"
    v-on:callback="$emit('setWeightToApplyToAddedHands', weightToApplyToAddedHandsVModel)"
  >
    <div class="vue-slider-tooltip" slot="tooltip" slot-scope="{ value }">
      Weight to apply to added hands: <strong>{{ value }}</strong>
    </div>
  </vue-slider>
</template>

<script>
import VueSlider from 'vue-slider-component';

export default {
  name: 'vertical-set-weight-to-apply-to-added-hands-basic',
  components: {
    'vue-slider': VueSlider,
  },
  props: ['weightToApplyToAddedHands', 'disabled', 'shortDeck'],
  data: function () {
    let height = this.shortDeck ? 350 : 440;

    return {
      weightToApplyToAddedHandsVModel: this.weightToApplyToAddedHands,
      sliderOptions: {
        min: 5,
        interval: 5,
        width: 4,
        height: height,
        direction: 'vertical',
        tooltip: 'hover',
        tooltipDir: 'top',
        style: {
          'margin-right': '5px',
          'margin-left': '-10px',
        },
        sliderStyle: {
          cursor: 'ns-resize',
        },
      },
    };
  },
  watch: {
    weightToApplyToAddedHands: function (newVal) {
      this.weightToApplyToAddedHandsVModel = newVal;
    },
  },
  methods: {
    refreshVueSlider: function () {
      let self = this;

      setTimeout(function () { // needs a setTimeout for some reason
        self.$refs.vueSlider.refresh();
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
  .vertical-set-weight-to-apply-to-added-hands-basic {
    display: inline-block;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/hand-weight/vertical-set-weight-to-apply-to-added-hands/vertical-set-weight-to-apply-to-added-hands-basic.vue